import { BuilderComponent } from "@builder.io/react";
import { UserAttributes } from "@builder.io/sdk/dist/src/builder.class";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { trackLoggedOutRetailersBuilderXpBucketing } from "@faire/web-api/events/loggedOutRetailers/actionUnknown/builderXpBucketing";
import AllSettings from "@faire/web-api/indigofair/settings/Serialized";
import { trackClientEvent } from "@faire/web-api/trackClientEvent";
import { TrackEvent } from "@faire/web-api/types";
import isChromatic from "chromatic/isChromatic";
import React, { PropsWithChildren } from "react";

import { isE2E } from "./builderUtils";
import { useBuilderSection } from "./useBuilderSection";

interface IProps extends PropsWithChildren {
  modelName: string;
  XPSettingName?: AllSettings;
  onViewEvent?: () => void;
  data?: object;
  targets?: UserAttributes;
}

export const RenderWithBuilder: React.FC<IProps> = ({
  modelName,
  XPSettingName,
  onViewEvent,
  data,
  targets,
}) => {
  const enabled = !isE2E() && !isChromatic();
  const sectionContent = useBuilderSection(modelName, enabled, targets);
  const ref = useDoActionWhenVisible(onViewEvent);

  if (!sectionContent) {
    return null;
  }
  return (
    <div ref={ref}>
      <BuilderComponent
        context={{
          // follow this guide https://www.builder.io/c/docs/custom-actions#in-builder-adding-an-on-click-event to add onClick event in Builder
          onClick: (params: TrackEvent) => {
            trackClientEvent(params);
          },
        }}
        content={sectionContent}
        model={modelName}
        data={data}
        contentLoaded={(_, content) => {
          const {
            id: contentId,
            name: contentName,
            testVariationId,
            testVariationName,
          } = content;
          if (XPSettingName) {
            trackLoggedOutRetailersBuilderXpBucketing(
              XPSettingName ?? "",
              contentId ?? "",
              contentName ?? "",
              testVariationId ?? "",
              testVariationName ?? ""
            );
          }
        }}
      />
    </div>
  );
};
